import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./component/Layout";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import GramsevakPage from "./pages/GramsevakPage";
import Gallery from "./pages/Gallery";
import VikasKame from "./pages/VikasKame";
import MeetingInfo from "./pages/MeetingInfo";

import JanmDakhala from "./pages/JanmDakhala";
import MrutDakhala from "./pages/MrutDakhala";
import VivahDakhala from "./pages/VivahDakhala";
import GramsevakServiceBook from './pages/GramsevakServiceBook';
import SarpanchKaryalaya from "./pages/SarpanchKaryalaya";
import UpSarpanchKaryalaya from "./pages/UpSarpanchKaryalaya";
import SadasyaKaryakarini from "./pages/SadasyaKaryakarini";


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/gramsevakpage" element={<GramsevakPage />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/vikas" element={<VikasKame />} />
          <Route path="/sabha" element={<MeetingInfo />} />
          
          <Route path="/janmdakhala" element={<JanmDakhala />} />
          <Route path="/death" element={<MrutDakhala />} />
          <Route path="/vivah" element={<VivahDakhala />} />
          <Route path="/gramsevak" element={<GramsevakServiceBook />} />
          <Route path="/sarpanch" element={<SarpanchKaryalaya />} />
          <Route path="/upsarpanch" element={<UpSarpanchKaryalaya />} />
          <Route path="/sadasya" element={<SadasyaKaryakarini />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
